:root {
  /* ==========================================================================
   Design System
   Color variables
   ========================================================================== */
  --beige: #bea96f;
  --beige-30: #f0e8d8;
  --beige-60: #d8c8a0;
  --green-dark: #1e9642;
  --green-mid-dark: #1fa040;
  --green: #20aa3f;
  --green-90: #48b753;
  --green-80: #66c368;
  --green-70: #93cf7c;
  --green-60: #addc91;
  --green-50: #bae0a2;
  --green-40: #c7e5b3;
  --green-30: #d4eac6;
  --green-20: #e2efd8;
  --green-10: #f0f8eb;
  --teal-dark: #005e5d;
  --teal-mid-dark: #126b69;
  --teal: #257675;
  --teal-90: #3e8685;
  --teal-80: #579695;
  --teal-70: #70a6a5;
  --teal-60: #89b6b5;
  --teal-50: #9ec4c3;
  --teal-40: #b4d2d1;
  --teal-30: #c4dddc;
  --teal-20: #d4e7e6;
  --teal-10: #f0f7f6;
  --pacific-dark: #0050b4;
  --pacific-mid-dark: #0061c1;
  --pacific: #0072ce;
  --pacific-90: #2284d5;
  --pacific-80: #4497dc;
  --pacific-70: #61a7e2;
  --pacific-60: #7eb7e8;
  --pacific-50: #96c4ed;
  --pacific-40: #afd2f2;
  --pacific-30: #c3ddf6;
  --pacific-20: #d6e8fa;
  --pacific-10: #eff8fd;
  --navy-dark: #002d72;
  --navy-mid-dark: #123c7c;
  --navy: #254b87;
  --navy-90: #3e5f95;
  --navy-80: #5674a3;
  --navy-70: #6f88b2;
  --navy-60: #889cc0;
  --navy-50: #9daecc;
  --navy-40: #b3c0d9;
  --navy-30: #c3cde2;
  --navy-20: #d3daeb;
  --navy-10: #f4f6fa;
  --purple-dark: #a01b68;
  --purple-mid-dark: #aa2071;
  --purple: #b4267a;
  --purple-90: #be438b;
  --purple-80: #c55998;
  --purple-70: #cd70a5;
  --purple-60: #d486b2;
  --purple-50: #dc9cbf;
  --purple-40: #e3b2cc;
  --purple-30: #ebc9d9;
  --purple-20: #f0d8e2;
  --purple-10: #fdf3f8;
  --red-dark: #b63014;
  --red-mid-dark: #c3381c;
  --red: #d14124;
  --red-90: #d75a40;
  --red-80: #dd735d;
  --red-70: #e28875;
  --red-60: #e79e8e;
  --red-50: #ebb0a3;
  --red-40: #f0c3b8;
  --red-30: #f3d1c8;
  --red-20: #f7e0d9;
  --red-10: #fbefec;
  --gold-dark: #dc731c;
  --gold-mid-dark: #ed881b;
  --gold: #ff9e1b;
  --gold-90: #ffab39;
  --gold-80: #ffb858;
  --gold-70: #ffc372;
  --gold-60: #ffce8d;
  --gold-50: #ffd8a3;
  --gold-40: #ffe1b9;
  --gold-30: #ffe8cb;
  --gold-20: #fff0dd;
  --gold-10: #fff6ec;
  --neutral-dark: #745745;
  --neutral-mid-dark: #7d604b;
  --neutral: #8a6c57;
  --neutral-90: #957865;
  --neutral-80: #a18573;
  --neutral-70: #ad9484;
  --neutral-60: #baa496;
  --neutral-50: #c6b4a9;
  --neutral-40: #d3c5bc;
  --neutral-30: #ddd1c9;
  --neutral-20: #e7ddd7;
  --neutral-10: #f8f5f2;
  --gray-darker: #293037;
  --gray-dark: #43484e;
  --gray-mid-dark: #4f5257;
  --gray: #5a5d61;
  --gray-90: #676a6f;
  --gray-80: #75787b;
  --gray-70: #838588;
  --gray-60: #919395;
  --gray-50: #a2a3a4;
  --gray-40: #b4b5b6;
  --gray-30: #c3c4c4;
  --gray-20: #d2d3d5;
  --gray-15: #dcdddf;
  --gray-10: #e7e8e9;
  --gray-5: #f7f8f9;
  --black: #101820;
  --white: #fff;
}

/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
:root {
  --font-stack: system-ui, sans-serif;
}

/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
.a-tagline {
  font-size: 0.75rem;
  display: grid;
  grid-template-columns: 22px 1fr;
  grid-column-gap: 10px;
}
.a-tagline__text {
  display: inline-block;
}
.a-tagline .u-usa-flag {
  margin-top: 1px;
}
.a-tagline--large {
  font-size: 1rem;
}
.a-tagline--large .u-usa-flag {
  margin-top: 4px;
}

.u-usa-flag {
  display: inline-block;
  width: 24px;
  height: 13px;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAZCAMAAABAf11LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAE5QTFRF////sxlC7MbQ2YyhxlNxCjFhR2WJV3GSKUt1dYumOFh/GT5rhZiwwszYsr/OlKW6Zn6c0djh8PL1iR9Ko7LE4OXrl0pttKC0pXWRtYKbSuJhRQAAANFJREFUeNrkkctuwyAUREnSuW/ApHYf//+jBVdZVcJi3aORgAXcMyLBAAJEzsVG3m8TkifyI3zfPQ6nJJLo421CArSBmkgjNEWtQE4zXJmClXuCWIlU5hdQxCqbqnE1KdIz79CVDvBwZxyKfQfmHTyzl01UZSvOWSTbhZLSWeDMufWLC/1ls3amT4qQq394EjIjApxBT+/nr8eEBNuKcB9SWMpmEXalNOylmlUZNTr4vE/4VdKhpC+leQf6y/e0wzL3RdJtkfUJyzwW+ZcdfgQYAJmJD3zerW6OAAAAAElFTkSuQmCC");
  background-size: contain;
  background-repeat: no-repeat;
}